import React from 'react';
import classnames from 'classnames';

import styles from './not-found-view.module.css';
import Message from '../Message';
import icon from '../../assets/icon-404.svg';

type NotFoundViewProps = {
    message: string;
    containerClassName?: string;
};

const NotFoundView = ({ message, containerClassName }: NotFoundViewProps) => {
    return (
        <>
            <div className={classnames(styles.container, containerClassName)}>
                <img src={icon} alt="" className={styles.icon} />
                <div className={styles.text}>
                    <div className={styles.headline}>
                        <h1 className={styles.textHeadline}>
                            <Message code="app.request.access.public.error.oops"></Message>
                        </h1>
                    </div>
                    <Message className={styles.subHeading} code={message}></Message>
                </div>
            </div>
        </>
    );
};

export default NotFoundView;
